import { usePostHog } from "posthog-js/react";
import { useCallback } from "react";

type EventProperties = Record<string, unknown>;

export const useTrackingEvent = () => {
  const posthog = usePostHog();

  const trackEvent = useCallback(
    (eventName: string, properties?: EventProperties) => {
      if (!posthog) {
        return;
      }
      posthog.capture(eventName, properties);
    },
    [posthog],
  );

  const setField = useCallback(
    (properties: EventProperties) => {
      if (!posthog) {
        return;
      }
      posthog.register(properties);
    },
    [posthog],
  );

  const setPersonProperties = useCallback(
    (properties: EventProperties) => {
      if (!posthog) {
        return;
      }
      posthog.setPersonProperties(properties);
    },
    [posthog],
  );

  const trackIdentify = (domainId: string | undefined, properties: Record<string, unknown>) => {
    if (!posthog) {
      return;
    }
    if (domainId) {
      posthog.identify(domainId, properties);
    }
  };

  const trackReset = () => {
    if (!posthog) {
      return;
    }
    posthog.reset();
  };

  return { setField, setPersonProperties, trackEvent, trackIdentify, trackReset };
};
